import { LABELS_LOAD, LABELS_LOAD_SUCCESS, LABELS_LOAD_FAIL } from './actions';


const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [],
  extraData: {},

};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LABELS_LOAD:
      return {
        ...state,
        loading: true,
      };
    case LABELS_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case LABELS_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
}
